export default __webpack_public_path__ + "static/media/successResource.3090f2c4.svg";